import PropTypes from 'prop-types'
import {
  MaleDailyArticleCardFive,
  MaleDailyArticleCardFour,
  MaleDailyArticleCardOne,
  MaleDailyArticleCardThree,
  MaleDailyArticleCardTwo,
} from './article_card'

const MaleDailyArticles = ({ articles, isMobile }) => {
  const device = isMobile ? 'mobile' : 'desktop'
  return (
    <>
      <div className={`maledaily-articles maledaily-articles--${device}`}>
        <div
          className={`maledaily-articles__title maledaily-articles__title--${device}`}
        >
          <span className={isMobile ? 'fd-heading-4' : 'fd-heading-2'}>
            Grooming & Men's Health Care
          </span>
        </div>
        <div
          className={`maledaily-articles__content maledaily-articles__content--${device}`}
        >
          <div
            className={`maledaily-articles__latest maledaily-articles__latest--${device}`}
          >
            <div className="maledaily-articles__main">
              {!!articles?.data?.[0] && (
                <MaleDailyArticleCardOne
                  title={articles?.data?.[0]?.title ?? '-'}
                  url={articles?.data?.[0]?.url}
                  category={articles?.data?.[0]?.category_slug}
                  image={articles?.data?.[0]?.image}
                  isMobile={isMobile}
                />
              )}

              {!isMobile && !!articles?.data?.[5] && (
                <MaleDailyArticleCardFour
                  title={articles?.data?.[5]?.title ?? '-'}
                  url={articles?.data?.[5]?.url}
                  category={articles?.data?.[5]?.category_slug}
                  isMobile={isMobile}
                />
              )}
            </div>
            <div
              className={`maledaily-articles__top maledaily-articles__top--${device}`}
            >
              <div
                className={`maledaily-articles__secondary maledaily-articles__secondary--${device}`}
              >
                {!!articles?.data?.[1] && (
                  <MaleDailyArticleCardTwo
                    title={articles?.data?.[1]?.title ?? '-'}
                    url={articles?.data?.[1]?.url}
                    category={articles?.data?.[1]?.category_slug}
                    image={articles?.data?.[1]?.image}
                    isMobile={isMobile}
                  />
                )}
                {!!articles?.data?.[2] && (
                  <MaleDailyArticleCardTwo
                    title={articles?.data?.[2]?.title ?? '-'}
                    url={articles?.data?.[2]?.url}
                    category={articles?.data?.[2]?.category_slug}
                    image={articles?.data?.[2]?.image}
                    isMobile={isMobile}
                  />
                )}
              </div>
              <div
                className={`maledaily-articles__tertiary maledaily-articles__tertiary--${device}`}
              >
                {!!articles?.data?.[3] && (
                  <MaleDailyArticleCardThree
                    title={articles?.data?.[3]?.title ?? '-'}
                    url={articles?.data?.[3]?.url}
                    category={articles?.data?.[3]?.category_slug}
                    image={articles?.data?.[3]?.image}
                    isMobile={isMobile}
                  />
                )}
                {!!articles?.data?.[4] && (
                  <MaleDailyArticleCardThree
                    title={articles?.data?.[4]?.title ?? '-'}
                    url={articles?.data?.[4]?.url}
                    category={articles?.data?.[4]?.category_slug}
                    image={articles?.data?.[4]?.image}
                    isMobile={isMobile}
                  />
                )}
              </div>

              {isMobile && !!articles?.data?.[5] && (
                <MaleDailyArticleCardFour
                  title={articles?.data?.[5]?.title ?? '-'}
                  url={articles?.data?.[5]?.url}
                  category={articles?.data?.[5]?.category_slug}
                  isMobile={isMobile}
                />
              )}
            </div>
          </div>
          <div
            className={`maledaily-articles__others maledaily-articles__others--${device}`}
          >
            {articles?.data?.slice(6, 12)?.map((article) => (
              <MaleDailyArticleCardFive
                key={article.id}
                title={article?.title ?? '-'}
                url={article?.url}
                category={article?.category_slug}
                image={article?.image}
                isMobile={isMobile}
              />
            ))}
          </div>
          <div className="maledaily-articles__action-wrapper">
            <a
              className={`maledaily-articles__button-more maledaily-articles__button-more--${device} fd-body-lg-bold`}
              href={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/tag/${process.env.NEXT_PUBLIC_MALE_DAILY_TAG}`}
            >
              More Articles
            </a>
          </div>
        </div>
      </div>

      <style jsx>
        {`
          .maledaily-articles {
            width: 100%;
            max-width: 1000px;
            margin: auto;
          }

          .maledaily-articles--mobile {
            max-width: 360px;
          }

          .maledaily-articles__title {
            text-align: center;
            margin-bottom: var(--space-40);
            color: #fff;
          }

          .maledaily-articles__title--mobile {
            margin-bottom: var(--space-20);
          }

          .maledaily-articles__content--mobile {
            padding: 0px var(--space-16);
          }

          .maledaily-articles__latest {
            display: grid;
            min-height: 768px;
            grid-template-columns: 400px 1fr;
            gap: 80px;
            margin-bottom: var(--space-80);
          }

          .maledaily-articles__latest--mobile {
            display: flex;
            flex-direction: column;
            height: auto;
            gap: 20px;
            margin-bottom: var(--space-20);
          }

          .maledaily-articles__main {
            display: flex;
            flex-direction: column;
            gap: 20px;
          }

          .maledaily-articles__top {
            display: flex;
            flex-direction: column;
            gap: 40px;
          }

          .maledaily-articles__top--mobile {
            gap: 20px;
          }

          .maledaily-articles__secondary {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 40px;
          }

          .maledaily-articles__secondary--mobile {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
          }

          .maledaily-articles__tertiary {
            display: flex;
            flex-direction: column;
            gap: 40px;
          }

          .maledaily-articles__tertiary--mobile {
            gap: 20px;
          }

          .maledaily-articles__others {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 80px 20px;
            margin-bottom: var(--space-40);
          }

          .maledaily-articles__others--mobile {
            display: flex;
            flex-direction: column;
            gap: 20px;
            margin-bottom: var(--space-20);
          }

          .maledaily-articles__action-wrapper {
            text-align: center;
          }

          .maledaily-articles__button-more {
            text-decoration: none;
            color: var(--text-default-inverse);
            background-color: #0032b1;
            padding: var(--space-12) var(--space-20);
            border-radius: var(--radius-8);
            margin: auto;
            display: inline-flex;
          }

          .maledaily-articles__button-more:hover,
          .maledaily-articles__button-more:active {
            background-color: #002d9f;
          }

          .maledaily-articles__button-more:active {
            transform: translateY(1px);
          }

          .maledaily-articles__button-more--mobile {
            display: block;
          }
        `}
      </style>
    </>
  )
}

MaleDailyArticles.propTypes = {
  isMobile: PropTypes.bool,
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  ),
}

export default MaleDailyArticles
